export const SET_REDUX_INITIAL_STATE = 'SET_REDUX_INITIAL_STATE';
export const SET_REDUX_STORE_PREFIX = 'SET_REDUX_STORE_PREFIX';
export const SET_REDUX_LANGUAGE = 'SET_REDUX_LANGUAGE';
